<mat-nav-list appAccordion class="navigation bg-dark">
  <ng-container *ngFor="let menuItem of menus">
    <mat-list-item appAccordionLink [attr.data-ci]="menuItem.name" group="{{ menuItem.state }}">
      <a appAccordionToggle class="relative" [routerLink]="['/' + menuItem.state]" *ngIf="menuItem.type === 'link'">
        <mat-icon color="secondary">{{ menuItem.icon }}</mat-icon>
        <span>{{ menuItem.name | translate }}</span>
        <span fxFlex></span>
        <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuItem.badge">{{ badge.value }}</span>
      </a>
      <a
        appAccordionToggle
        class="relative"
        href="{{ menuItem.state }}"
        target="_blank"
        *ngIf="menuItem.type === 'extTabLink'"
      >
        <mat-icon color="primary">{{ menuItem.icon }}</mat-icon>
        <span>{{ menuItem.name | translate }}</span>
        <span fxFlex></span>
        <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuItem.badge">{{ badge.value }}</span>
      </a>
      <a
        appAccordionToggle
        class="relative"
        href="javascript:;"
        *ngIf="menuItem.type === 'sub' && menuItem.children && menuItem.children.length"
      >
        <mat-icon color="primary">{{ menuItem.icon }}</mat-icon>
        <span>{{ menuItem.name | translate }}</span>
        <span fxFlex></span>
        <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuItem.badge">{{ badge.value }}</span>
        <mat-icon color="primary" class="menu-caret text-white">arrow_drop_down</mat-icon>
      </a>
      <mat-nav-list class="sub-menu" *ngIf="menuItem.type === 'sub'">
        <ng-container *ngFor="let childitem of menuItem.children">
          <mat-list-item [attr.data-ci]="childitem.name" routerLinkActive="open">
            <a [routerLink]="['/', menuItem.state, childitem.state]" class="relative">{{
              childitem.name | translate
            }}</a>
          </mat-list-item>
        </ng-container>
      </mat-nav-list>
    </mat-list-item>
  </ng-container>
</mat-nav-list>

<button mat-icon-button class="xlarge" (click)="openChatbotDialog()" *ngIf="devMode">
  <mat-icon color="primary" svgIcon="graam-head"></mat-icon>
</button>
